import React from "react";
import { Link } from "react-router-dom";
const EvenementenMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("items")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fas fa-calendar-alt"></i></span>
            <span className="menu-text">VVV Evenementen</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/evenementen" className="menu-link">
                <span className="menu-icon"><i className="fas fa-calendar-alt"></i></span>
                <span className="menu-text">Evenementen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/evenementen/jaarlijks" className="menu-link">
                <span className="menu-icon"><i className="fas fa-calendar-alt"></i></span>
                <span className="menu-text">Jaarlijks</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default EvenementenMenu;
